import compose from 'recompose/compose';
import { withRouter } from 'react-router';
import withProps from 'recompose/withProps';
import moment from 'moment';
import withState from 'recompose/withState';
import { connect } from 'react-redux';
import withPropsOnChange from 'recompose/withPropsOnChange';
import get from 'lodash/get';

import config from '../../../../config';
import { getWaitingListCustomersIsFetching } from '../waitingListCustomers/selectors';

const WaitingListContainer = fetch =>
  compose(
    withRouter,
    withProps({
      startDate: moment()
        .add(config.showedWeeks.from, 'w')
        .format(config.dateFormatISO),
      endDate: moment()
        .add(config.showedWeeks.to, 'w')
        .format(config.dateFormatISO),
    }),
    withState('currentDate', 'setCurrentDate', props =>
      get(props, 'location.query.date', moment().format(config.dateFormatISO))
    ),
    connect(state => ({
      isFetching: getWaitingListCustomersIsFetching(state),
    })),
    fetch,
    withPropsOnChange(['currentDate'], (props) => {
      props.fetch(props.currentDate);
    })
  );

export default WaitingListContainer;
